"use client";

import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useState } from "react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div className="flex gap-1">
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
        <div className="h-9 w-16 bg-muted animate-pulse rounded-md" />
      </div>;
  }
  return <>
      <div className="hidden lg:flex items-center gap-2">
        <NavigationMenu viewport={false}>
          <NavigationMenuList>
            {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
                <NavigationMenuLink asChild>
                  <Link to={item.href || "#"} className="text-foreground-light hover:text-foreground transition-colors duration-[var(--duration-medium)]">
                    {item.label}
                  </Link>
                </NavigationMenuLink>
              </NavigationMenuItem>)}
          </NavigationMenuList>
        </NavigationMenu>
        <Button asChild className="ml-2 bg-primary hover:bg-primary-hover text-foreground scale-100 hover:scale-[1.02] transition-transform duration-[var(--duration-fast)]">
          <Link to="#">Get a Quote</Link>
        </Button>
      </div>

      <Button variant="ghost" size="icon" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-foreground-light hover:text-foreground" aria-label="Toggle menu">
        {mobileMenuOpen ? <X className="size-6" /> : <Menu className="size-6" />}
      </Button>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-light-background border-t border-border shadow-medium lg:hidden z-50">
          <nav className="flex flex-col p-4 gap-2">
            {menuItems.map((item, i) => <Link key={item.id} data-index={i} to={item.href || "#"} className="text-foreground-light hover:text-foreground transition-colors duration-[var(--duration-medium)] py-2 px-3 rounded-md hover:bg-muted-light-background" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
            <Button asChild className="mt-2 bg-primary hover:bg-primary-hover text-foreground w-full">
              <Link to="#" onClick={() => setMobileMenuOpen(false)}>
                Get a Quote
              </Link>
            </Button>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  return <>
      <div className="w-full bg-dark-background py-6">
        <div className="container mx-auto px-4">
          <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-bold text-foreground-dark text-center">
            A+ Fire Electrical Services
          </h1>
        </div>
      </div>
      
      <header className="w-full bg-light-background border-b border-border sticky top-0 z-40">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between relative">
          <div className="flex-1 flex items-center">
            <Link to="/" className="flex-shrink-0">
              <img src="https://apfire.10web.cloud/wp-content/uploads/2025/12/cropped-cropped-ChatGPT-Image-Dec-9-2025-at-06_47_54-PM-1.png" alt="A+ Fire" className="h-7" />
            </Link>
          </div>

          <div className="flex-shrink-0 flex justify-center px-2">
            <Button asChild className="bg-red-600 hover:bg-red-700 text-white font-bold scale-100 hover:scale-[1.02] transition-transform duration-[var(--duration-fast)] shadow-sm text-[10px] sm:text-xs lg:text-sm whitespace-nowrap px-2 sm:px-4">
              <Link to="sms:+17036237279?body=I%20need%20emergency%20service!">
                I NEED EMERGENCY SERVICE!
              </Link>
            </Button>
          </div>

          <MenuProvider menu_id="9" className="flex-1 flex justify-end">
            <HeaderMenuConsumer />
          </MenuProvider>
        </div>
      </header>
    </>;
}